var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardRsvpCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86926 1.96738C1.68208 1.96738 1.53035 2.11911 1.53035 2.30629V7.05107C1.53035 7.23825 1.68208 7.38998 1.86926 7.38998H6.61393C6.8011 7.38998 6.95284 7.23825 6.95284 7.05107V2.30629C6.95284 2.11911 6.8011 1.96738 6.61393 1.96738H1.86926ZM0.852539 2.30629C0.852539 1.74476 1.30774 1.28955 1.86926 1.28955H6.61393C7.17545 1.28955 7.63065 1.74476 7.63065 2.30629V7.05107C7.63065 7.6126 7.17545 8.06781 6.61393 8.06781H1.86926C1.30774 8.06781 0.852539 7.6126 0.852539 7.05107V2.30629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59769 0.612305C5.78487 0.612305 5.9366 0.764041 5.9366 0.951218V2.30687C5.9366 2.49405 5.78487 2.64578 5.59769 2.64578C5.41052 2.64578 5.25879 2.49405 5.25879 2.30687V0.951218C5.25879 0.764041 5.41052 0.612305 5.59769 0.612305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88578 0.612305C3.07295 0.612305 3.22469 0.764041 3.22469 0.951218V2.30687C3.22469 2.49405 3.07295 2.64578 2.88578 2.64578C2.69861 2.64578 2.54688 2.49405 2.54688 2.30687V0.951218C2.54688 0.764041 2.69861 0.612305 2.88578 0.612305Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.852539 3.66264C0.852539 3.47547 1.00427 3.32373 1.19144 3.32373H7.29174C7.47891 3.32373 7.63065 3.47547 7.63065 3.66264C7.63065 3.84982 7.47891 4.00156 7.29174 4.00156H1.19144C1.00427 4.00156 0.852539 3.84982 0.852539 3.66264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRsvpCalendarIcon);
export default __webpack_public_path__ + "static/media/dashboard-rsvp-calendar-icon.b481d5a1ae0fdadf90bb6ca275a3bb93.svg";
export { ForwardRef as ReactComponent };